import { Button } from 'react-bootstrap';
import { FaChevronRight } from 'react-icons/fa';
import { VscLoading } from 'react-icons/vsc';
import { FormattedMessage } from 'react-intl';

function NextBtn({ type = 'submit', isLoading, onClick }) {
  return (
    <Button
      variant="primary"
      type={type}
      className="d-flex btn-sm justify-content-center align-items-center ml-2"
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}>
      {isLoading ? (
        <VscLoading className="spin" />
      ) : (
        <>
          {/* {icon ? '' : <RiSendPlaneFill color="white" className="me-2" />}
          {buttonText ? buttonText : <FormattedMessage id="button.submit" />} */}
          <FaChevronRight className="me-2" /> <FormattedMessage id="button.next" />
        </>
      )}
      {/* <FormattedMessage id="button.next" /> <FaChevronRight className="ms-2" /> */}
    </Button>
  );
}

export default NextBtn;
